module.exports = __webpack_public_path__ + "img/ERP_swiperTab_bg5.d652284d.png";